<script setup>
import { InitApp, themeOverrides } from '~/utils/initApp'
import { useDefaultSeo } from '~/hooks/seo'
import { useRtl } from '~/hooks'
import { useStorage } from '@vueuse/core'
import { unstableScrollbarRtl, unstableStepsRtl } from 'naive-ui'
import { useStore } from './store'
import { inUniAppOrApp } from '@/utils/inApp'

const { locale } = useI18n()
const { isRtl } = useRtl()
const route = useRoute()
const store = useStore()

if (inUniAppOrApp && route.query.theme) {
  localStorage.setItem('uniapp-ttx-theme', route.query.theme)
}

function setTheme() {
  const queryTheme = route.query.theme
  const metaTheme = route.meta.theme
  const storageTheme = route.meta.needThemeStorage ? useStorage('futures-ttx-theme', store.defaultTheme).value : ''
  store.theme = inUniAppOrApp ? localStorage.getItem('uniapp-ttx-theme') : (queryTheme || metaTheme || storageTheme || store.defaultTheme)
}
setTheme()
watch(() => route.path, setTheme, { deep: true })
InitApp()
useDefaultSeo()
</script>

<template>
  <Html
    :lang="locale"
    :dir="isRtl ? 'rtl' : 'ltr'"
    :theme="store.theme"
    class="h-screen"
  >
    <Body
      class="h-screen overflow-hidden text-sm antialiased text-textPrimary"
      :dir="isRtl ? 'rtl' : 'ltr'"
    >
      <n-config-provider
        preflight-style-disabled
        :theme-overrides="themeOverrides"
        :rtl="isRtl ? [unstableStepsRtl, unstableScrollbarRtl] : []"
      >
        <n-message-provider>
          <NuxtLayout>
            <NuxtPage />
            <common-message-handler />
          </NuxtLayout>
        </n-message-provider>
      </n-config-provider>
    </Body>
  </Html>
</template>
